import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../api/axios';

export default function AdminShipping() {
  const [form, setForm] = useState(null);
  const [locating, setLocating] = useState(false);

  useEffect(() => {
    api.get('/shipping/config').then((res) => setForm(res.data));
  }, []);

  const detectOrigin = () => {
    if (!navigator.geolocation) {
      toast.error('Geolocation not supported');
      return;
    }
    setLocating(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setForm((f) => ({ ...f, originLat: pos.coords.latitude, originLng: pos.coords.longitude }));
        setLocating(false);
        toast.success('Warehouse location captured from device GPS');
      },
      () => {
        toast.error('Could not access location');
        setLocating(false);
      }
    );
  };

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put('/shipping/config', form);
      toast.success('Shipping distance rules saved successfully');
    } catch (err) {
      toast.error('Could not save shipping settings');
    }
  };

  if (!form) return <div className="p-8 text-[#8A796C]">Loading shipping configuration...</div>;

  return (
    <div className="space-y-6 text-[#2B1810] max-w-4xl">
      <div className="bg-white border border-[#E8DFD8] rounded-xl p-6 shadow-sm">
        <h1 className="font-heading text-2xl font-bold text-[#2B1810]">Shipping & Distance Matrix Settings</h1>
        <p className="text-xs text-[#8A796C]">Configure warehouse origin coordinates, per-kilometer rates, and COD options.</p>
      </div>

      <form onSubmit={save} className="bg-white border border-[#E8DFD8] rounded-xl p-6 shadow-sm space-y-6">
        {/* Origin Section */}
        <div className="space-y-4 border-b border-[#E8DFD8] pb-6">
          <h3 className="font-heading text-base font-bold text-[#2B1810]">1. Warehouse Origin Location</h3>
          <div>
            <label className="label">Warehouse / Origin Label</label>
            <input className="input-field" value={form.originLabel} onChange={(e) => setForm({ ...form, originLabel: e.target.value })} />
          </div>

          <button 
            type="button" 
            onClick={detectOrigin} 
            disabled={locating} 
            className="bg-[#FAF8F5] hover:bg-[#F5EFEB] border border-[#C49A45] text-[#2B1810] font-bold text-xs uppercase tracking-wider py-2.5 px-4 rounded transition-colors flex items-center gap-2"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C49A45" strokeWidth="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            {locating ? 'Detecting GPS...' : 'Use My Current Device Location as Warehouse Origin'}
          </button>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="label">Origin Latitude</label>
              <input type="number" step="any" className="input-field" value={form.originLat} onChange={(e) => setForm({ ...form, originLat: Number(e.target.value) })} />
            </div>
            <div>
              <label className="label">Origin Longitude</label>
              <input type="number" step="any" className="input-field" value={form.originLng} onChange={(e) => setForm({ ...form, originLng: Number(e.target.value) })} />
            </div>
          </div>
        </div>

        {/* Pricing Matrix Section */}
        <div className="space-y-4 border-b border-[#E8DFD8] pb-6">
          <h3 className="font-heading text-base font-bold text-[#2B1810]">2. Distance Pricing Matrix (₹)</h3>
          <div className="grid md:grid-cols-3 gap-4">
            <div>
              <label className="label">Base Fee (₹)</label>
              <input type="number" className="input-field" value={form.baseFee} onChange={(e) => setForm({ ...form, baseFee: Number(e.target.value) })} />
            </div>
            <div>
              <label className="label">Rate per KM (₹)</label>
              <input type="number" className="input-field" value={form.perKmRate} onChange={(e) => setForm({ ...form, perKmRate: Number(e.target.value) })} />
            </div>
            <div>
              <label className="label">Free Shipping Above (₹)</label>
              <input type="number" className="input-field" value={form.freeShippingAboveAmount} onChange={(e) => setForm({ ...form, freeShippingAboveAmount: Number(e.target.value) })} />
            </div>
            <div>
              <label className="label">Minimum Shipping Cost (₹)</label>
              <input type="number" className="input-field" value={form.minShippingCost} onChange={(e) => setForm({ ...form, minShippingCost: Number(e.target.value) })} />
            </div>
            <div>
              <label className="label">Maximum Shipping Cost (₹)</label>
              <input type="number" className="input-field" value={form.maxShippingCost} onChange={(e) => setForm({ ...form, maxShippingCost: Number(e.target.value) })} />
            </div>
            <div>
              <label className="label">COD Extra Fee (₹)</label>
              <input type="number" className="input-field" value={form.codExtraFee} onChange={(e) => setForm({ ...form, codExtraFee: Number(e.target.value) })} />
            </div>
          </div>

          <label className="flex items-center gap-2 text-xs font-bold text-[#2B1810] pt-2">
            <input type="checkbox" className="accent-[#C49A45] w-4 h-4" checked={form.codAvailable} onChange={(e) => setForm({ ...form, codAvailable: e.target.checked })} />
            Enable Cash on Delivery (COD) Option
          </label>
        </div>

        <button type="submit" className="bg-[#C49A45] hover:bg-[#B08736] text-white font-bold text-xs uppercase tracking-widest px-8 py-3 rounded shadow transition-colors">
          SAVE SHIPPING LOGISTICS SETTINGS
        </button>
      </form>
    </div>
  );
}
